/* eslint-disable @typescript-eslint/no-unused-vars */
import { AuditOutlined } from '@ant-design/icons';
import { Row, Col } from 'antd';
import { billingSelectors, workSpaceSelectors } from 'containers/App/selectors';
import { useScrollTop } from 'hooks';
import { resetAll, resetSearchValue } from 'pages/BillingProcess/slices';
import { getFieldEditInvoice } from 'pages/BillingProcess/thunk';
import { FC, useState } from 'react';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation, Redirect } from 'react-router-dom';
import { HeaderTitle, HeaderBillingRegister, BackToStepPrevBill } from 'components';
import { t_medical_institution } from 'types';
import BillingFirstStep from './RegisterFirstStep';
import BillingFiveStep from './RegisterFiveStep';
import BillingOtherFiveStep from './RegisterFiveStepOther';
import BillingFourStep from './RegisterFourStep';
import BillingSecondStep from './RegisterSecondStep/index';
import Step6 from './RegisterSixStep';
import BillingThirdStep from './RegisterThirdStep/index';
import { Wrapper } from './styles';

const BillingProcess: FC = () => {
  useScrollTop();
  const history = useHistory();
  const dispatch = useDispatch();
  const location = useLocation<{ medicalDetail: t_medical_institution }>();
  const { itemInvoice, fieldEditInvoice } = useSelector(billingSelectors);
  const { statusBill } = useSelector(workSpaceSelectors);

  useEffect(() => {
    dispatch(getFieldEditInvoice());
  }, [dispatch]);

  useEffect(() => {
    return () => {
      dispatch(resetAll());
    };
  }, [dispatch]);

  useEffect(() => {
    return () => {
      if (history.location.pathname !== '/billing_process') {
        dispatch(resetSearchValue());
      }
    };
  }, [dispatch, history.location.pathname]);

  const detailItemSelected = () => {
    history.push('/billing_process');
  };

  const [currentStep, setCurrentStep] = useState<number>(0);

  const stepToPrevious = () => {
    setCurrentStep(currentStep - 1);
  };
  const nextStep = () => {
    currentStep < 6 && setCurrentStep(1 + currentStep);
  };

  const screen = () => {
    switch (currentStep) {
      case 0:
        return <BillingFirstStep nextStep={nextStep} />;
      case 1:
        return <BillingSecondStep nextStep={nextStep} stepToPrevious={stepToPrevious} />;
      case 2:
        return <BillingThirdStep nextStep={nextStep} stepToPrevious={stepToPrevious} />;
      case 3:
        return <BillingFourStep nextStep={nextStep} stepToPrevious={stepToPrevious} />;
      case 4:
        return <BillingOtherFiveStep nextStep={nextStep} stepToPrevious={stepToPrevious} />;
      case 5:
        return <BillingFiveStep nextStep={nextStep} stepToPrevious={stepToPrevious} />;
      case 6:
        return <Step6 />;
    }
  };

  if (!location.state) {
    return <Redirect to="/billing_process" />;
  }

  return (
    <Wrapper>
      <HeaderTitle title="請求処理" icon={AuditOutlined} />
      <BackToStepPrevBill backToPrev={detailItemSelected} />
      <Row className="header-choose">
        <Col className="extraLargeFont" span={18}>
          {(location.state ? location.state.medicalDetail.facility_name : '') +
            (itemInvoice
              ? `${itemInvoice?.invoice_month?.slice(0, 4)}年${itemInvoice?.invoice_month?.slice(4)}月`
              : '')}
          {statusBill && statusBill.value === itemInvoice?.invoice_month ? '【確定】' : ''}
        </Col>
        <Col span={6}>{renderStatusClinic(itemInvoice?.editing_status_by_clinic || '', fieldEditInvoice ?? [])}</Col>
      </Row>
      <Row className="header-choose">
        <Col span={23}>
          <HeaderBillingRegister currentStep={currentStep} backStepPrevious={stepToPrevious} />
        </Col>
      </Row>
      <Row>
        <Col span={24}>{screen()}</Col>
      </Row>
    </Wrapper>
  );
};

const renderStatusClinic = (value: string, options: any[]) => {
  const key = options.find((f) => f.value === value);
  if (!key) {
    return null;
  }
  switch (key.display_id) {
    case 'o_editing':
      return <div className="status-clinic">医療機関編集中</div>;
    case 'o_end':
      return <div className="status-clinic">医療機関編集終了</div>;
    default:
      return '';
  }
};

export default BillingProcess;
